var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mb-2"},[_c('AppFilter',{attrs:{"filters":_vm.filterConfig,"filter-submitting":_vm.filterSubmitting},on:{"filter":_vm.handleFilter}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }